/**
 * Handles toggle for chinas qr code
 * @module qrCodeToggle
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'qrCodeToggle';
export const DEFAULTS = {};

const qrCodeToggleEventHandlers = ($el) => {
  const qrCodeImage = $('.site-footer-qr');
  $el.on('click', () => {
    qrCodeImage.toggle();
  });
};

export default function qrCodeToggle() {
  const $el = $('.js-site-footer-qr-btn');
  qrCodeToggleEventHandlers($el);
}

registerJQueryPlugin(PLUGIN_NAME, qrCodeToggle);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/qr-code-toggle.js